import { rp, fmtDate, fmtTime, fmtAcc } from "@/lib/format";

const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const TYPE_LABEL = { pokok: "Simpanan Pokok", wajib: "Simpanan Wajib", sukarela: "Simpanan Sukarela" };

export function printReceipt(tx, member) {
  const isIn = tx.direction === "in";
  const w = window.open("", "_blank", "width=420,height=720");
  if (!w) return false;
  const row = (k, v) => `<tr><td>${esc(k)}</td><td class="r">${esc(v)}</td></tr>`;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Struk ${esc(tx.tx_id)}</title>
<style>
  @page { size: 58mm auto; margin: 3mm; }
  * { box-sizing: border-box; }
  body { font-family: "Courier New", monospace; font-size: 11px; color: #000; width: 58mm; margin: 0 auto; padding: 4px; }
  .c { text-align: center; } .r { text-align: right; } .b { font-weight: bold; }
  img { width: 100%; max-width: 52mm; height: auto; }
  hr { border: 0; border-top: 1px dashed #000; margin: 6px 0; }
  table { width: 100%; border-collapse: collapse; } td { padding: 1px 0; vertical-align: top; }
  .amt { font-size: 15px; font-weight: bold; text-align: center; margin: 6px 0; }
  .noprint { margin-top: 12px; text-align: center; }
  @media print { .noprint { display: none; } }
</style></head><body>
  <div class="c"><img src="${window.location.origin}/brand-banner.webp" alt="Credit Union Tuah Talino"/></div>
  <hr/>
  <div class="c b">STRUK ${isIn ? "SETORAN" : "PENARIKAN"}</div>
  <hr/>
  <table>
    ${row("No. Struk", tx.tx_id.toUpperCase())}
    ${row("Tanggal", fmtDate(tx.created_at))}
    ${row("Jam", fmtTime(tx.created_at))}
  </table>
  <hr/>
  <table>
    ${row("Nama", member.name)}
    ${row("No. Anggota", member.member_no)}
    ${member.account_no ? row("No. Rek", fmtAcc(member.account_no)) : ""}
    ${row("Jenis", TYPE_LABEL[tx.type] || tx.type)}
    ${row("Ket.", tx.description)}
  </table>
  <div class="amt">${isIn ? "" : "- "}${esc(rp(tx.amount))}</div>
  <hr/>
  <table>${row("Petugas", tx.by_name || "-")}${row("Jabatan", tx.by_position || "-")}</table>
  <hr/>
  <div class="c">Simpan struk ini sebagai bukti transaksi yang sah.<br/>Bersama Tumbuh, Bersama Sejahtera</div>
  <div class="noprint"><button onclick="window.print()">Cetak</button></div>
  <script>window.onload = () => setTimeout(() => window.print(), 300);</script>
</body></html>`);
  w.document.close();
  return true;
}
